// Category icon mapping
export const getCategoryIcon = (category) => {
  const iconMap = {
    "Activity Management": "task_alt",
    Workflow: "account_tree",
    Communication: "chat_bubble",
    Documents: "description",
    BYODb: "storage",
    "Pro Code": "code",
    Entity: "dataset",
    "Owner Management": "manage_accounts",
    "Data Management": "database",
    Navigation: "navigation",
    Invoice: "receipt",
    AI: "psychology",
    Utility: "build",
    other: "category"
  };
  return iconMap[category] || "widgets";
};

// Job template icon mapping
export const getJobTemplateIcon = (jobTemplate) => {
  const iconMap = {
    perform_activity: "play_circle",
    perform_activity_bg: "autoplay",
    start_state_machine: "rocket_launch",
    start_state_machine_bg: "autorenew",
    start_state_machine_offline: "cloud_off",
    send_sms_bg: "sms",
    send_email_bg: "email",
    send_whatsapp_bg: "chat",
    send_slack_msg_bg: "forum",
    send_telegram_msg_bg: "send",
    custom_js: "javascript",
    execute_pro_code: "terminal",
    rdbms_insert: "add_circle",
    rdbms_update: "update",
    postgres_insert: "add_box",
    postgres_update: "system_update",
    mongo_template_insert: "add_to_queue",
    edit_appuser_fields: "edit",
    edit_entity_bg: "edit_note",
    edit_entity_fe: "edit_document",
    edit_self_entity_bg: "person_edit",
    edit_sm_bg: "settings",
    edit_parent_sm_bg: "supervisor_account",
    edit_linked_sm_bg: "link",
    add_todo: "checklist",
    make_html_to_pdf: "picture_as_pdf",
    send_google_doc: "article",
    send_excel_doc: "table_chart",
    schedule_activity_bg: "schedule",
    create_payment: "payment",
    grid_to_sm_bg: "grid_on",
    sm_to_grid_fe: "view_module",
    navigate_device: "open_in_new",
    navigate_back: "arrow_back",
    refresh_page: "refresh",
    refresh_page_components: "sync",
    set_owner_bg: "person_add",
    register_entity_bg: "app_registration",
    ocr: "document_scanner",
    text_notification: "notifications",
    create_community_user: "group_add",
    update_community_user: "group",
    add_community_user_to_group: "person_add_alt",
    remove_community_user_to_group: "person_remove",
    update_community_user_fields: "badge",
    vapi_voice_ai: "record_voice_over",
    perform_sap_operation: "business",
    make_http_request: "http",
    set_global_variables: "settings_suggest",
    add_user_to_group: "group_add",
    remove_user_from_group: "group_remove",
    execute_sql_query: "query_stats",
    json_to_grid: "data_object",
    generate_page_url: "link",
    register_app_user: "person_add",
    edit_sm_by_filter_bg: "filter_alt",
    assign_roles_position_activity: "assignment_turned_in",
    // Add custom node icon mappings
    if_else: "alt_route",
    if_else_if: "device_hub",
    switch: "call_split",
    transform: "transform",
    merge: "merge",
    distribute: "share"
  };
  return iconMap[jobTemplate] || "other_admission";
};
